(() => {
  const theme = window.theme || { routes: {}, moneyFormat: '${{amount}}', cartType: 'drawer' };
  const routes = Object.assign({ cart_url: '/cart', cart_add_url: '/cart/add', cart_change_url: '/cart/change' }, theme.routes);

  /* ------------------------------------------------------------------ */
  /* Utilidades                                                          */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || theme.moneyFormat || '${{amount}}';
    const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const delimit = (n, decimals, thousands, decimal) => {
      const fixed = (n / 100).toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withThousands + decimal + frac : withThousands;
    };
    let value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = delimit(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  const lockScroll = (lock) => { document.documentElement.style.overflow = lock ? 'hidden' : ''; };

  /* ------------------------------------------------------------------ */
  /* Menú lateral                                                        */
  /* ------------------------------------------------------------------ */
  const menu = document.querySelector('[data-menu-drawer]');
  function openMenu(focusSearch) {
    if (!menu) return;
    menu.classList.add('is-open');
    lockScroll(true);
    document.querySelectorAll('[aria-controls="MenuDrawer"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const target = focusSearch ? menu.querySelector('[data-drawer-search]') : menu.querySelector('button, a');
    setTimeout(() => target && target.focus(), 50);
  }
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    lockScroll(false);
    document.querySelectorAll('[aria-controls="MenuDrawer"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }

  /* ------------------------------------------------------------------ */
  /* Carrito                                                             */
  /* ------------------------------------------------------------------ */
  const drawer = document.querySelector('[data-cart-drawer]');

  function openCart() {
    if (!drawer || theme.cartType === 'page') { window.location.href = routes.cart_url; return; }
    drawer.classList.add('is-open');
    lockScroll(true);
    const close = drawer.querySelector('[data-cart-close]');
    setTimeout(() => close && close.focus(), 50);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    lockScroll(false);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
  }

  function renderDrawer(html) {
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-inner]');
    const current = drawer.querySelector('[data-cart-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(fresh.dataset.itemCount);
    }
  }

  async function changeLine(line, quantity) {
    if (drawer) drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: 'cart-drawer' })
      });
      const data = await res.json();
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      else updateCount(data.item_count);
    } catch (e) {
      window.location.reload();
    } finally {
      if (drawer) drawer.classList.remove('is-loading');
    }
  }

  async function addToCart(form) {
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-form-error]');
    if (error) error.hidden = true;
    if (button) button.classList.add('is-loading');

    const formData = new FormData(form);
    const body = { items: [{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) }], sections: 'cart-drawer' };

    try {
      const res = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        if (error) { error.textContent = data.description || data.message || 'No se pudo agregar el producto.'; error.hidden = false; }
        return;
      }
      if (theme.cartType === 'page' || !drawer) { window.location.href = routes.cart_url; return; }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      openCart();
    } catch (e) {
      form.submit();
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  /* ------------------------------------------------------------------ */
  /* Eventos globales (delegación)                                       */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const t = e.target;

    const menuOpen = t.closest('[data-menu-open]');
    if (menuOpen) { e.preventDefault(); openMenu(menuOpen.hasAttribute('data-focus-search')); return; }
    if (t.closest('[data-menu-close]')) { closeMenu(); return; }

    const cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && drawer && theme.cartType !== 'page' && !document.querySelector('[data-cart-page]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }

    const remove = t.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(Number(remove.dataset.lineRemove), 0); return; }

    const minus = t.closest('[data-qty-minus]');
    const plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      const input = (minus || plus).closest('[data-qty]').querySelector('input');
      const min = input.hasAttribute('data-line-qty') ? 0 : 1;
      const next = Math.max(min, Number(input.value || 0) + (plus ? 1 : -1));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', (e) => {
    const lineInput = e.target.closest('[data-line-qty]');
    if (lineInput) changeLine(Number(lineInput.dataset.lineQty), Number(lineInput.value));

    const sort = e.target.closest('[data-sort-select]');
    if (sort) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || theme.cartType === 'page') return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeMenu(); closeCart(); }
  });

  /* ------------------------------------------------------------------ */
  /* Banner principal                                                    */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const slides = track ? track.children : [];
    if (slides.length < 2) return;
    const dots = root.querySelectorAll('[data-slide-dot]');
    let index = 0;
    let timer;

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };
    const start = () => {
      if (root.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), Number(root.dataset.speed) || 5000);
    };

    root.querySelector('[data-slide-prev]')?.addEventListener('click', () => { go(index - 1); start(); });
    root.querySelector('[data-slide-next]')?.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.slideDot)); start(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);

    let startX = null;
    root.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      startX = null;
    });
    start();
  });

  /* ------------------------------------------------------------------ */
  /* Carruseles de productos                                             */
  /* ------------------------------------------------------------------ */
  function initSlider(root) {
    const track = root.querySelector('[data-slider-track]');
    const prev = root.querySelector('[data-slider-prev]');
    const next = root.querySelector('[data-slider-next]');
    if (!track) return;
    const step = () => track.clientWidth * 0.9;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next?.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  document.querySelectorAll('[data-slider]').forEach(initSlider);

  /* Pestañas de categorías */
  document.querySelectorAll('[data-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-tab-panel]');
    const list = root.querySelector('[data-tabs-list]');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t, n) => t.setAttribute('aria-selected', n === i ? 'true' : 'false'));
        panels.forEach((p, n) => { p.hidden = n !== i; });
        const slider = panels[i]?.querySelector('[data-slider-track]');
        if (slider) slider.dispatchEvent(new Event('scroll'));
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });
    root.querySelectorAll('[data-tabs-scroll]').forEach((btn) => {
      btn.addEventListener('click', () => list && list.scrollBy({ left: Number(btn.dataset.tabsScroll) * 200 }));
    });
  });

  /* ------------------------------------------------------------------ */
  /* Página de producto: galería, variantes, barra fija                  */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const gallery = section.querySelector('[data-gallery]');
    const showMedia = (id) => {
      if (!gallery || !id) return;
      gallery.querySelectorAll('[data-media-id]').forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(id)));
      gallery.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };
    gallery?.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.thumb));
    });

    const jsonEl = section.querySelector('[data-product-json]');
    const picker = section.querySelector('[data-variant-picker]');
    if (jsonEl && picker) {
      const product = JSON.parse(jsonEl.textContent);
      const idInput = section.querySelector('[data-variant-id]');
      const addButton = section.querySelector('[data-add-button]');
      const addText = section.querySelector('[data-add-text]');
      const defaultLabel = addText ? addText.textContent : '';
      const savings = section.querySelector('[data-savings]');

      const selected = () => Array.from(picker.querySelectorAll('fieldset')).map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      const markUnavailable = () => {
        const current = selected();
        picker.querySelectorAll('input[type="radio"]').forEach((input) => {
          const idx = Number(input.dataset.optionIndex);
          const combo = current.slice();
          combo[idx] = input.value;
          const exists = product.variants.some((v) => v.available && v.options.every((o, n) => o === combo[n]));
          const label = picker.querySelector(`label[for="${input.id}"]`);
          if (label) label.classList.toggle('is-unavailable', !exists);
        });
      };

      picker.addEventListener('change', (e) => {
        const input = e.target;
        if (input.dataset.optionIndex !== undefined) {
          const label = picker.querySelector(`[data-option-label="${input.dataset.optionIndex}"]`);
          if (label) label.textContent = input.value;
        }
        const values = selected();
        const variant = product.variants.find((v) => v.options.every((o, n) => o === values[n]));
        markUnavailable();

        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addText) addText.textContent = 'No disponible';
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (addButton) addButton.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? defaultLabel : 'Agotado';

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        section.querySelectorAll('[data-price]').forEach((price) => {
          price.classList.toggle('price--on-sale', !!onSale);
          const cur = price.querySelector('[data-price-current]');
          const cmp = price.querySelector('[data-price-compare]');
          const badge = price.querySelector('[data-price-badge]');
          if (cur) cur.textContent = formatMoney(variant.price);
          if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
          if (badge) {
            badge.hidden = !onSale;
            badge.textContent = onSale ? `-${Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)}%` : '';
          }
        });
        if (savings) {
          savings.hidden = !onSale;
          savings.textContent = onSale ? `Ahorras ${formatMoney(variant.compare_at_price - variant.price)}` : '';
        }

        if (variant.featured_media) showMedia(variant.featured_media.id);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
      markUnavailable();
    }

    const sticky = section.querySelector('[data-sticky-atc]');
    const mainButton = section.querySelector('[data-add-button]');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('sticky-atc-visible', show);
      });
      observer.observe(mainButton);
    }
  });

  /* Navegación inferior móvil: reservar espacio */
  if (document.querySelector('[data-bottom-nav]')) document.body.classList.add('has-bottom-nav');
})();
